import { SectionCard } from "shared/app/LeadsTableView/components/CreateLeadModal/SectionCard";
import { CreateLeadPayload } from "shared/app/LeadsTableView/components/CreateLeadModal/useFormController";
import { BaseInput, InputSize, Select, Show } from "shared/components";
import { RegisterTyped } from "shared/hooks";
import { LEAD_TYPE_OPTIONS, LeadType } from "views/leads-id/types";

export const BasicInfoSection = ({
  register,
  wrapperClassName,
  isTitleDisabled = false,
  cardClassName,
  showTypeSelect = false,
  leadType,
  onLeadTypeChange,
  typeSelectDisabled = false,
  typeOptions = LEAD_TYPE_OPTIONS,
  typeHint
}: {
  register: RegisterTyped<CreateLeadPayload>;
  wrapperClassName?: string;
  isTitleDisabled?: boolean;
  cardClassName?: string;
  showTypeSelect?: boolean;
  leadType?: LeadType;
  onLeadTypeChange?: (value: LeadType) => void;
  typeSelectDisabled?: boolean;
  typeOptions?: { label: string; value: LeadType }[];
  typeHint?: string | null;
}) => {
  return (
    <SectionCard
      title="Basic information"
      wrapperClassName={wrapperClassName}
      isTitleDisabled={isTitleDisabled}
      cardClassName={cardClassName}
    >
      <div className="space-y-4">
        <div className="flex w-full gap-4">
          <div className="w-full">
            <BaseInput
              {...register("first_name")}
              id="firstName"
              labelClassName="mb-1.5"
              size={InputSize.BASE}
              label="First name"
              required
            />
          </div>

          <div className="w-full">
            <BaseInput
              {...register("last_name")}
              id="lastName"
              labelClassName="mb-1.5"
              size={InputSize.BASE}
              label="Last name"
              required
            />
          </div>
        </div>

        <Show if={showTypeSelect}>
          <div className="w-full max-w-[335px]">
            <Select
              id="leadType"
              label="Type"
              labelClassName="mb-1.5"
              hideOptional
              size={InputSize.BASE}
              value={leadType}
              options={typeOptions}
              isDisabled={typeSelectDisabled}
              onChange={(e) => {
                const option = typeOptions.find(
                  (typeOption) => typeOption.value === e.target.value
                );
                if (option) onLeadTypeChange?.(option.value);
              }}
              legacyErrorMargins={false}
            />
            <Show if={Boolean(typeHint)}>
              <p className="mt-1.5 text-xs text-content-300">{typeHint}</p>
            </Show>
          </div>
        </Show>
      </div>
    </SectionCard>
  );
};
